import React, { useState, useEffect } from 'react';
import axios from 'axios';

const PhoneDetails = () => {
  const [phoneDetails, setPhoneDetails] = useState({
    phoneNumber: '',
    imei: '',
    model: '',
    brand: '',
    lastKnownLocation: {
      latitude: '',
      longitude: ''
    }
  });

  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  // Get the current geolocation when the component mounts
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setPhoneDetails((prevDetails) => ({
            ...prevDetails,
            lastKnownLocation: {
              latitude,
              longitude
            }
          }));
        },
        (error) => {
          setError('Unable to retrieve your location.');
        }
      );
    } else {
      setError('Geolocation is not supported by this browser.');
    }
  }, []);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPhoneDetails({
      ...phoneDetails,
      [name]: name === 'latitude' || name === 'longitude'
        ? {
            ...phoneDetails.lastKnownLocation,
            [name]: value
          }
        : value
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post('https://phone-tracker-backend-wqeb.onrender.com/api/phones/register', phoneDetails);
      setMessage(response.data.message);
      setPhoneDetails({
        phoneNumber: '',
        imei: '',
        model: '',
        brand: '',
        lastKnownLocation: { latitude: '', longitude: '' }
      });
      setError('');
    } catch (error) {
      setError(error.response ? error.response.data.message : 'Error registering phone');
      setMessage('');
    }
  };

  return (
    <div className="phone-details">
      <h2>Register Phone</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="phoneNumber">Phone Number</label>
          <input
            type="text"
            id="phoneNumber"
            name="phoneNumber"
            value={phoneDetails.phoneNumber}
            onChange={handleInputChange}
            required
          />
        </div>
        <div>
          <label htmlFor="imei">IMEI</label>
          <input
            type="text"
            id="imei"
            name="imei"
            value={phoneDetails.imei}
            onChange={handleInputChange}
            required
          />
        </div>
        <div>
          <label htmlFor="model">Model</label>
          <input
            type="text"
            id="model"
            name="model"
            value={phoneDetails.model}
            onChange={handleInputChange}
            required
          />
        </div>
        <div>
          <label htmlFor="brand">Brand</label>
          <input
            type="text"
            id="brand"
            name="brand"
            value={phoneDetails.brand}
            onChange={handleInputChange}
            required
          />
        </div>
        <div>
          <label htmlFor="latitude">Latitude</label>
          <input
            type="number"
            id="latitude"
            name="latitude"
            value={phoneDetails.lastKnownLocation.latitude}
            onChange={handleInputChange}
            required
          />
        </div>
        <div>
          <label htmlFor="longitude">Longitude</label>
          <input
            type="number"
            id="longitude"
            name="longitude"
            value={phoneDetails.lastKnownLocation.longitude}
            onChange={handleInputChange}
            required
          />
        </div>
        <button type="submit">Register Phone</button>
      </form>

      {error && <div className="error">{error}</div>}
      {message && <div className="message">{message}</div>}
    </div>
  );
};

export default PhoneDetails;
